import React from 'react';
import { motion } from 'framer-motion';
import styles from './LivePollIndicator.module.css';

interface LivePollIndicatorProps {
  label?: string;
}

export function LivePollIndicator({ label = 'Polling for new photos' }: LivePollIndicatorProps) {
  return (
    <motion.div
      className={styles.root}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.2 }}
    >
      <motion.span
        className={styles.dot}
        animate={{ scale: [1, 1.5, 1], opacity: [1, 0.5, 1] }}
        transition={{ repeat: Infinity, duration: 2, ease: 'easeInOut' }}
      />
      {label}
    </motion.div>
  );
}
